import React, { useRef, useState } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { getDeviationType } from '@wix/da-shared-react/pkg/DeviationViews/_helpers';
import { DeviationTypes } from '@wix/da-shared-react/pkg/types/deviation';
import MediaService from '@wix/da-shared-react/pkg/utils/DeviationMediaService';
import { isiOS } from '@wix/da-shared-react/pkg/utils/browser';
import FakeFilmThumb from './FakeFilmThumb';
import ImagePreviewLayout from '../ImagePreviewLayout';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import cn from 'classnames';

import s from './ImagePreview.scss';

export interface Props {
  className?: string;
  deviation?: PapiDeviation;
}

const ImagePreview: React.FC<Props> = ({ className, deviation }) => {
  const imgRef = useRef<HTMLImageElement>(null);
  const preview =
    deviation && MediaService.getDeviationFile(deviation, 'preview');

  const [loadHasFired, setLoadHasFired] = useState(false);
  const ignoreLoading = isiOS();
  const loaded = ignoreLoading || imgRef.current?.complete || loadHasFired;

  const isFilm = getDeviationType(deviation) === DeviationTypes.FILM;
  const isPublished = deviation?.isPublished;
  const showFakeFilmThumb = isFilm && !isPublished;

  return (
    <ImagePreviewLayout className={className}>
      {deviation && showFakeFilmThumb && <FakeFilmThumb />}
      {!loaded && !isFilm && <LoadingIndicator className={s['loader']} />}
      {deviation && !showFakeFilmThumb && (
        <img
          ref={imgRef}
          className={cn(
            s['image'],
            loaded && s['loaded'],
            ignoreLoading && s['fuck-safari']
          )}
          src={preview?.src}
          alt="Upload preview"
          onLoad={() => {
            setLoadHasFired(true);
          }}
        />
      )}
    </ImagePreviewLayout>
  );
};
ImagePreview.displayName = 'ImagePreview';

export default ImagePreview;
